import { render, staticRenderFns } from "./data_panorama.vue?vue&type=template&id=f23104aa&scoped=true&"
import script from "./data_panorama.vue?vue&type=script&lang=js&"
export * from "./data_panorama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f23104aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f23104aa')) {
      api.createRecord('f23104aa', component.options)
    } else {
      api.reload('f23104aa', component.options)
    }
    module.hot.accept("./data_panorama.vue?vue&type=template&id=f23104aa&scoped=true&", function () {
      api.rerender('f23104aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/memorandum/inside/body/addon/land/tabs/data_panorama.vue"
export default component.exports